if (!customElements.get('koota-lazy-reviews')) {
  class KootaLazyReviews extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template');
      if (!this.template) return;

      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.load();
          this.observer?.disconnect();
        },
        { rootMargin: '500px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    load() {
      if (this.dataset.loaded === 'true' || !this.template) return;

      this.append(this.template.content.cloneNode(true));
      this.template.remove();
      this.dataset.loaded = 'true';
      this.classList.add('is-loaded');
      this.setAttribute('aria-busy', 'false');
    }
  }

  customElements.define('koota-lazy-reviews', KootaLazyReviews);
}
